export const STATUS_SERVICE = {
	INITIAL: 0,
	INPROGRESS: 1,
	SUCCESS: 2,
	ERROR: 4

}


// WEBPACK FOOTER //
// ./src/constants/app/services.js